const floorsObj = {
  init: (container,  floor, tooltip) => {
      let $tooltip = $(tooltip);
      let $tooltipContainer = $(container);
      let $floor = $(floor);
      let $zones = $floor.find('.floor-plan-svg a, .floor-plan-svg g'); // a for floors g for parking
      let lang = document.documentElement.lang;

      $zones.each(function() {
          //global
          let $this = $(this);
          let id = $this.attr('id');
          let house = $this.parent().data('house');
          const room = dataCore[house][id];

          if(room == undefined) return;
          if(house == 'parking' || house == 'Parking') {
              $this.addClass('room-colors');
              if(room['type'] == "vieta automobiliui") $this.addClass('room-parking-0');
              else if(room['type'] == "Sandėliukai") $this.addClass('room-parking-2');
              else $this.addClass('room-parking-1');

              if(room['status'] === 'Parduotas') {
                  $this.addClass('room-sold');
                  $(`.floor-plan-sold g[id="${$this.attr('id')}"]`).addClass('white-sold');
              } else if(room['status'] === 'Rezervuotas') {
                  $this.addClass('reserved');
                  $(`.floor-plan-sold g[id="${$this.attr('id')}"]`).addClass('white-sold');
              }
          } else {
              //console.log(room,house);
              $this.addClass('room-colors');
              $this.addClass(`room-${room['rooms'][0]}`);
              if(room['status'] === 'Parduotas')  {
                  $this.addClass('room-sold');
                  $(`.floor-plan-sold a[id="${$this.attr('id')}"]`).addClass('white-sold');
              } else if(room['status'] === 'Rezervuotas') {
                  //$this.addClass('reserved');
                  $(`.floor-plan-sold a[id="${$this.attr('id')}"]`).addClass('white-sold');
              }    
          }

          //console.log('end ' + id);

          if ($this.is('g')) return;
    
          //a tag
          // add filter to the end
          // $this.on('click', function(e) {
          //     let $this = $(this);
          //     let id = $this.attr('id');
          //     if(data[id]['status'] == 'Parduotas') {
          //         e.preventDefault();
          //         return;
          //     }
          //     $this.attr("href", `${$this.attr("href")}${window.location.search}`);
          // });

          if(room['status'] != 'Parduotas') {
              let url = FLOORURL + '/' + house;

              const link = `${url}/${room['floor']}/${id}`;
              $this.attr("href", link);
          } else {
              // disabled sold floors
              $this.on('click', function(e) {e.preventDefault();});
          }
      });

  
      $zones.on('mouseenter', function() {
          //global
          let $this = $(this);
          let id = $this.attr('id');
          let house = $this.parent().data('house');
          let floor = $this.parent().data('floor');
          let d = dataCore[house][id];

          if(d['dualFloor'] === floor) floor = d['dualFloor'];
  
          if(house === 'Parking') {
              $tooltipContainer =  $(`.floor-svg[data-floor="Parking"][data-house="any"]`);
          } else {
              $tooltipContainer =  $(`.floor-svg[data-floor="${floor}"][data-house="${house}"]`);
          }

          $tooltip = $tooltipContainer.find('.floor-tooltip');

          if(d === undefined) return;

          //parking
          if ($this.is('g')) {
              $tooltip.find('.rooms').hide();
              $tooltip.find(".letter").text(id);
              
              let type = 'vieta automobiliui';
              if(d['type'] === 'Dviračių saugyklos') {
                  type = $('#tooltip0').text();
              } else if(d['type'] === 'Sandėliukai') {
                  type = $('#tooltip1').text();
              } else {
                  type = $('#tooltip2').text();
              }

              $tooltip.find('.title').text(type);

              if(lang == 'en') {
                $tooltip.find('.status').text($tooltip.find('.status').data(d['status'].toLowerCase()));
              } else {
                if(d['type'] === 'vieta automobiliui' || d['type'] === 'Dviračių saugyklos') {
                    $tooltip.find('.status').text(d['status'].substring(0, d['status'].length-1));
                }else {
                    $tooltip.find('.status').text(d['status']);
                }
              }
           
              if(d['status'] != 'Parduotas' && d['price'] != undefined) $tooltip.find('p.price').text(d['price'] + ' €');
              else $tooltip.find('p.price').text('');
              if(d['status'] != 'Parduotas') {
                  $tooltip.find('.price').show();
                  $tooltip.find('.details').show();
                  $tooltip.find('.sold').hide();
              } else {
                  $tooltip.find('.price').hide();
                  $tooltip.find('.details').hide();
                  $tooltip.find('.sold').show();
              }

              // discount
              if(d['price_disc'] != 0 && d['price_disc'] != undefined) {
                  $tooltip.find('p.price').hide();
                  $tooltip.find('.discount').show();
                  $tooltip.find('.new-price').text(d['price_disc'] + ' €');
                  $tooltip.find('.old-price').text(d['price'] + ' €');
              } else {
                  $tooltip.find('.discount').hide();
              }

              if(d['area'] != '0,00') {
                  $tooltip.find('.area-value').text(d['area']);
                  $tooltip.find('.area').show();
              } else {
                  $tooltip.find('.area').hide();
              }

              $tooltip.addClass('tooltip-about-show');
              return;
          }

          const dsc = document.documentElement.lang === 'lt' ? d['descr'] : d['descr_en'];

          if(dsc === '') $tooltip.find('.message').addClass('hidden');
          else $tooltip.find('.message').removeClass('hidden');

          $tooltip.find('.message-text').html(dsc);

          //floors
          if(d['commercial'] === '1') {
              $tooltip.find('.title').text($tooltip.find('.title').data('b'));
              $tooltip.find('.rooms').hide();
          } else {
              $tooltip.find('.title').text($tooltip.find('.title').data('a'));
              $tooltip.find('.rooms').show();
          }
          
          $tooltip.find('.letter').text(id);

          if(lang == 'en') {
            $tooltip.find('.status').text($tooltip.find('.status').data(d['status'].toLowerCase()));
          } else {
            $tooltip.find('.status').text(d['commercial'] == '1' ? d['status'].replace('as', 'os') : d['status']);
          }

          $tooltip.find('.area-value').text(d['area'].replace(/\s/g, ''));
          if(d['status'] != 'Parduotas' && d['price'] != undefined) $tooltip.find('p.price').text(d['price'] + ' €');
          else $tooltip.find('p.price').text('');

          if(d['status'] != 'Parduotas') {
              $tooltip.find('.price').show();
              $tooltip.find('.details').show();
              $tooltip.find('.sold').hide();
          } else {
              $tooltip.find('.price').hide();
              $tooltip.find('.details').hide();
              $tooltip.find('.sold').show();
          }

          // discount
          if(d['price_disc'] != 0 && d['price_disc'] != undefined) {
              $tooltip.find('p.price').hide();
              $tooltip.find('.discount').show();
              $tooltip.find('.new-price').text(d['price_disc'] + ' €');
              $tooltip.find('.old-price').text(d['price'] + ' €');
          } else {
              $tooltip.find('.discount').hide();
          }
     
          $tooltip.find('.rooms-value').text(d['rooms'].split(',0')[0]);
          $tooltip.addClass('tooltip-about-show');
          //end

      }).on('mouseleave', function(){
          $tooltip.removeClass('tooltip-about-show');
      }).on('mousemove',function(event){
     
          let width = $(window).width();
          let offset = $tooltipContainer.offset();
          let x = event.pageX - offset.left - 1;
          let y = event.pageY - offset.top - $tooltip.height() - 30;

          if((x + 230) > width) {
              x -= 230;//(x + 230) - width;
          }

          $tooltip.css({
              left : x,
              top : y
          });
      });
  }
}
